import EaseNumber from "~/lib/EaseNumber.js";
import { PHRASE } from "./index.js";
import { clamp, random } from "~/lib/utils.js";

export default class CameraShaker {
    constructor(camera) {
        this._camera = camera;
        this._shakeAmount = new EaseNumber(0, 0.01);
        this._ox = null;
        this._oy = null;
    }

    shake(phrase) {
        const threshold = 5 * this._shakeAmount.value;
        this._shakeAmount.value = phrase == PHRASE.BOOSTING ? 5 : 0;

        if (this._ox == null) {
            if (this._shakeAmount.value < 0.1) return;
            this._setOriginPos();
        }

        this._camera.position.x += random(-1, 1) * this._shakeAmount.value;
        this._camera.position.y += random(-1, 1) * this._shakeAmount.value;

        this._camera.position.x = clamp(
            this._camera.position.x,
            this._ox - threshold,
            this._ox + threshold,
        );

        this._camera.position.y = clamp(
            this._camera.position.y,
            this._oy - threshold,
            this._oy + threshold,
        );
    }

    destroy() {
        this._shakeAmount.destroy();
    }

    _setOriginPos() {
        this._ox = this._camera.position.x;
        this._oy = this._camera.position.y;
    }
}
